import { FC, ReactNode, useMemo, useReducer } from 'react'
import { reducer } from '../../reducers/app-reducer/app-reducer'
import { GlobalContext, initialState } from './global-context'

interface Props {
  children: ReactNode
}

const GlobalProvider: FC<Props> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const contextValue = useMemo(() => ({ state, dispatch }), [state])

  return <GlobalContext.Provider value={contextValue}>
    {children}
  </GlobalContext.Provider>
}

export default GlobalProvider